import { createRoute } from '@tanstack/react-router'
import { rootRoute } from 'router/root-route'
import { z } from 'zod'

import { OrderYarcheRedirect } from '../components/OrderYarcheRedirect'

const searchSchema = z.object({
  auth_code: z.string(),
  state: z.string()
})

export const orderYarcheRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/order-yarche-redirect',
  component: OrderYarcheRedirect,
  validateSearch: searchSchema
})
